module.exports = __webpack_public_path__ + "static/img/logo.f5880ed3.png";